/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1LocationCountriesCountryidLangsIdMutationRequest,
  PutApiV1LocationCountriesCountryidLangsIdMutationResponse,
  PutApiV1LocationCountriesCountryidLangsIdPathParams,
  PutApiV1LocationCountriesCountryidLangsId400,
  PutApiV1LocationCountriesCountryidLangsId401,
  PutApiV1LocationCountriesCountryidLangsId404,
  PutApiV1LocationCountriesCountryidLangsId500,
} from "../../types/locationCountryLangController/PutApiV1LocationCountriesCountryidLangsId.ts";

function getPutApiV1LocationCountriesCountryidLangsIdUrl(
  countryId: PutApiV1LocationCountriesCountryidLangsIdPathParams["countryId"],
  id: PutApiV1LocationCountriesCountryidLangsIdPathParams["id"],
) {
  const res = {
    method: "PUT",
    url: `/api/v1/location/countries/${countryId}/langs/${id}` as const,
  };
  return res;
}

/**
 * @description Atualiza os dados de uma tradução (idioma) de país. **(Requer Authorization para autenticação)**
 * @summary Atualizar idioma do país (Requer Authorization para autenticação)
 * {@link /api/v1/location/countries/:countryId/langs/:id}
 */
export async function putApiV1LocationCountriesCountryidLangsId(
  countryId: PutApiV1LocationCountriesCountryidLangsIdPathParams["countryId"],
  id: PutApiV1LocationCountriesCountryidLangsIdPathParams["id"],
  data?: PutApiV1LocationCountriesCountryidLangsIdMutationRequest,
  config: Partial<
    RequestConfig<PutApiV1LocationCountriesCountryidLangsIdMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PutApiV1LocationCountriesCountryidLangsIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1LocationCountriesCountryidLangsId400
      | PutApiV1LocationCountriesCountryidLangsId401
      | PutApiV1LocationCountriesCountryidLangsId404
      | PutApiV1LocationCountriesCountryidLangsId500
    >,
    PutApiV1LocationCountriesCountryidLangsIdMutationRequest
  >({
    method: "PUT",
    url: getPutApiV1LocationCountriesCountryidLangsIdUrl(
      countryId,
      id,
    ).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
